import { getAllLocalizationLanguages, getLanguagleById } from "../constants/localization.constant";

export interface LocalizationData {
    id: string;
    localizedNames: LocalizedName;
}

export interface LocalizedName{
    languageMap: Map<LocalizationLanguage, string>;
}

export class LocalizationLanguage{
    id!: string;
    name!: string;

    constructor(){}

    static fromJson(json: string): LocalizationLanguage {
        const plainObject = JSON.parse(json);

        let result = getLanguagleById(plainObject.id) ?? new LocalizationLanguage();
    
        return result;
      }
}

export function createLocalizationLanguage(_id: string, _name: string): LocalizationLanguage{
    return {id: _id, name: _name};
}